// extracted by mini-css-extract-plugin
export default {"footerRoot":"footer_footerRoot__Z1Kpd","footerrow":"footer_footerrow__EtgXP","footerlogo":"footer_footerlogo__d2dud"};